module.exports = __webpack_public_path__ + "img/f580238.png";